/**
 * Consistent color assignment per employee for utilization reports.
 * Same employee = same color across all charts and timeline.
 */

export const EMPLOYEE_COLOR_PALETTE = [
  "#3b82f6", // blue
  "#10b981", // emerald
  "#f59e0b", // amber
  "#ef4444", // red
  "#8b5cf6", // violet
  "#ec4899", // pink
  "#06b6d4", // cyan
  "#84cc16", // lime
  "#f97316", // orange
  "#6366f1", // indigo
  "#14b8a6", // teal
  "#a855f7", // purple
] as const;

/**
 * Creates a map of userId -> hex color for consistent coloring across views.
 * Uses deterministic assignment based on user order (sorted by name for stability).
 */
export function createEmployeeColorMap(
  userIds: string[],
  userNames?: Record<string, string>
): Record<string, string> {
  const map: Record<string, string> = {};
  const sorted = [...userIds].sort((a, b) => {
    const nameA = userNames?.[a] ?? a;
    const nameB = userNames?.[b] ?? b;
    return nameA.localeCompare(nameB);
  });
  sorted.forEach((userId, index) => {
    map[userId] = EMPLOYEE_COLOR_PALETTE[index % EMPLOYEE_COLOR_PALETTE.length];
  });
  return map;
}
